module.exports = __webpack_public_path__ + "static/media/Registered.cd2966e9.png";